<div style="min-height: 75vh; display: flex; justify-content: center; align-items: center;">
  <div class="text-center">
    <h4 i18n="messaggio pagina non trovata|Pagina non trovata">404 Pagina non trovata</h4>
    <a [routerLink]="['/']" i18n="Messaggio torna indietro|Pagina non trovata">Torna alla ricerca</a>
  </div>
</div>
